import { FC } from 'react';
import TooltipModal from 'shared/components/tooltipModal';
import './styles.scss';

interface FormSubTitleProps {
	title: string;
	dialogTitle?: string;
	dialogContent?: string;
}

const FormSubTitle: FC<FormSubTitleProps> = (props) => {
	const { title, dialogTitle, dialogContent } = props;

	return (
		<div className="formSubTitle">
			{title}
			{(dialogTitle || dialogContent) && (
				<TooltipModal
					dialogTitle={dialogTitle}
					dialogContent={dialogContent}
					cyTestRef="pep-info"
					cyDescriptionTestRef="pep-message"
					cyActionTextRef="popup-ok"
				/>
			)}
		</div>
	);
};

export default FormSubTitle;
